import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentLanguage, setLanguage } from 'lib/slices';
import useLocalStorage from 'utils/hooks/useLocalStorage';
import { useEffect } from 'react';

export default function useSelectLanguage() {
    const dispatch = useDispatch();
    const language = useSelector(selectCurrentLanguage);
    const [storedValue, setLangInStorage] = useLocalStorage<string | null>(
        'languageCode',
        null,
    );

    const handleChange = (_, value) => {
        setLangInStorage(value);
        dispatch(setLanguage(value));
    };

    useEffect(() => {
        console.log('storedValue', storedValue);
        dispatch(setLanguage(storedValue || 'eng'));
    }, [storedValue, dispatch]);

    return [language, handleChange];
}
